import { APIProvider, Map, Marker } from "@vis.gl/react-google-maps";
import React from "react";

const Location = () => {
    const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

    const mapContainerStyle = {
        width: "90vw", // width at 90% of the viewport
        height: "80vh", // height at 80% of the viewport
        maxWidth: "1200px", // optional: set a max width
        margin: "0 auto", // center horizontally
        borderRadius: "10px", // optional: rounded corners
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)", // optional: add shadow
    };

    const containerStyle = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: "40px",
    };

    // Define the location (lat/lng)
    const location = { lat: 46.322432, lng: 16.130725 };

    return (
        <div className="container" id="location">
            <div className="section-title about-text text-center">
                <h2>Lokacija</h2>
            </div>
            <div style={containerStyle}>
                <APIProvider apiKey={API_KEY}>
                    <Map
                        style={mapContainerStyle}
                        defaultCenter={location}
                        defaultZoom={15} 
                        gestureHandling={"greedy"}
                        disableDefaultUI={true}
                    >
                        <Marker position={location} />
                    </Map>
                </APIProvider>
            </div>
        </div>
    );
};

export default Location;
